import { createFileRoute } from '@tanstack/react-router'
import { ProfilePage } from '@/pages/ProfilePage'
import { requireAuth } from '@/utils/routeGuards.ts'

const ProfileRoute = () => {
  return <ProfilePage />
}

export const Route = createFileRoute('/profile')({
  beforeLoad: requireAuth,
  component: ProfileRoute,
})
